export default __webpack_public_path__ + "static/media/TheGreekPassion_BohuslavMartinů.f62d9a98.mp4";